// extracted by mini-css-extract-plugin
module.exports = {"blockCommon":"shopify-link__blockCommon___3BQFI","ShopifyLink":"shopify-link__ShopifyLink___3PBVU"};